import { clientSideMetrics } from '@marketplace-web/observability/client-metrics-util'

export const incrementCatalogLoad = (
  type: 'success' | 'error',
  source: 'api_items' | 'error_boundary',
) => {
  clientSideMetrics.counter('catalog_load', { type, source }).increment()
}
